export default __webpack_public_path__ + "static/media/secure-payment.89961c0b.svg";